/* mapDataUtil.js */

"use strict";
function getDefaultCreateValue(
    vendor,
    key,
    vendorOptions = [],
    keyOptions = [],
    withVendor = true
) {
    if (!vendor) {
        return "";
    }
    const vendorOpt = vendorOptions.find((vopt) => vopt.value === vendor);
    const vendorLabel = vendorOpt ? vendorOpt.label : vendor;
    if (!key) {
        return vendorLabel;
    }
    const keyOpt = keyOptions.find((kopt) => kopt.value === key);
    const keyLabel = keyOpt ? keyOpt.label : key;
    return withVendor ? vendorLabel + " - " + keyLabel : keyLabel;
}

module.exports = getDefaultCreateValue;
